import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "./i18n";
import "deep-chat";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "../src/assets/css/reset.less";
import "../src/assets/css/tb-feedback.less";

import VueAxios from "vue-axios";
import axios from "axios";

import scroll from "vue-seamless-scroll";
import VueClipboards from "vue-clipboard2";
import elTableInfiniteScroll from "el-table-infinite-scroll";
import VueContextMenu from "vue-contextmenu";
import CopyPlugin from "@/plugins/copy";
import TbMessagePlugin from "@/plugins/tbMessage";
import TbProDialogPlugin from "@/plugins/tbProDialog";
import NumberFormatPlugin from "@/plugins/numberFormat";
import FormatPlugin from "@/plugins/format";

import intro from "intro.js";
import "intro.js/introjs.css";
import "intro.js/themes/introjs-modern.css";
import "../src/assets/css/fonts.css";
import tool from "@/utils/tool.js";
import tronfn from "@/utils/tron.js";
import { displaynotify } from "@/utils/displaynote";
import global from "@/components/Global.vue";
import PublicIcon from "@/components/icons/publicIcon.vue";
import moment from "moment";

import {
  getsiteConfig,
  getConfigValue,
  waitForSiteConfig,
  refreshSiteConfig,
} from "@/utils/site";
import { installWindowOpenCompat } from "@/utils/windowOpenHelper";
import { initTokenSync } from "@/utils/tokenSync";
import { startAccessTokenMonitor } from "@/utils/authTokenManager";
import {
  buildDownloadFileName,
  downloadBlob,
  downloadUrl,
} from "@/utils/fileDownload";
import {
  initNotificationSocket,
  syncNotificationSocket,
} from "@/utils/notificationSocket";
import Chat from "vue-beautiful-chat";
// import VueAdvancedChat from "vue-advanced-chat";
// import "vue-advanced-chat/dist/vue-advanced-chat.css";

// === Vue 插件注册 ===
// 配置 Element UI 使用 i18n 进行国际化
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value),
});
Vue.use(VueAxios, axios);
Vue.use(scroll);
Vue.use(VueClipboards);
Vue.use(elTableInfiniteScroll);
Vue.use(VueContextMenu);
Vue.use(Chat);

// 注册Vue Advanced Chat组件
// Vue.use(VueAdvancedChat);
Vue.use(CopyPlugin);
Vue.use(TbMessagePlugin);
Vue.use(TbProDialogPlugin);
Vue.use(NumberFormatPlugin);
Vue.use(FormatPlugin);

// 全局注册公共图标组件
Vue.component("PublicIcon", PublicIcon);

// === 全局方法/变量挂载 ===
Vue.prototype.$intro = intro;
Vue.prototype.$moment = moment;
Vue.prototype.tool = tool;
Vue.prototype.tronfn = tronfn;
Vue.prototype.displaynotify = displaynotify;
Vue.prototype.GLOBAL = global;
Vue.prototype.getsiteConfig = getsiteConfig;
Vue.prototype.getConfigValue = getConfigValue;
Vue.prototype.waitForSiteConfig = waitForSiteConfig;
Vue.prototype.refreshSiteConfig = refreshSiteConfig;
Vue.prototype.filesfn = downloadBlob;
Vue.prototype.$downloadUrl = downloadUrl;
Vue.prototype.$downloadFileName = buildDownloadFileName;
// 全局弹窗方法
// 按钮布局：右侧主按钮 = 「保存画布」（留在画布），左侧按钮 = 「退出」（离开画布）。
// 参数：onLeave = 退出时执行，onStay = 保存画布 / 关闭弹窗时执行。
Vue.prototype.$showDialog = function (message, onLeave, onStay) {
  this.$confirm(message, i18n.t("components.savedialog.tip"), {
    confirmButtonText: i18n.t("components.savedialog.saveCanvas"),
    cancelButtonText: i18n.t("components.savedialog.exit"),
    type: "warning",
    customClass: "tb-custom-dialog",
    distinguishCancelAndClose: true,
    showCancelButton: true, // 始终显示按钮
    beforeClose: (action, instance, done) => {
      if (action === "confirm") {
        // 「保存画布」：演示模式下阻止保存，否则标记临时画布已保存
        if (getConfigValue("demoSite")) {
          this.$tbMessage({
            type: "warning",
            text: "当前模式下不允许保存画布",
          });
        } else {
          sessionStorage.canvastemporarily = true;
        }
      }
      done();
    },
  })
    .then(() => {
      // 点击「保存画布」（右侧主按钮）：留在画布
      onStay();
    })
    .catch((action) => {
      if (action === "close") {
        // 点右上角 X：等同留在画布，保持原行为
        onStay();
      } else {
        // 点击「退出」（左侧按钮）：离开画布
        onLeave();
      }
    });
};

// === 全局挂载给 HTML 使用 ===
window.siteConfig = {
  get: getConfigValue,
  load: async () => {
    await getsiteConfig();
    // 👇不要重复派发事件，这个已经在 site.js 里处理了
  },
};

installWindowOpenCompat();
initTokenSync();
startAccessTokenMonitor();
initNotificationSocket();
router.afterEach(() => {
  syncNotificationSocket();
});

// Vue 启动
Vue.config.productionTip = false;
new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");

console.log("window.siteConfig loaded:", window.siteConfig);
